import React from "react";
import {
    MDBSpinner,
    MDBBtn,
    MDBTable,
    MDBTableBody,
    MDBTableHead,
    MDBChip,
    MDBModal,
    MDBModalHeader,
    MDBModalBody,
    MDBModalFooter,
    MDBIcon, MDBCollapse
} from 'mdbreact';
import { getTypesenseClient } from "../../../utils/typesenseClient";
import './organization.css'

class BuyerOrgList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dbBuyerOrgs: [],
            last: null,
            buyerPerPage: 12,
            notMore: false,
            showMenu: null,
            showMenuIndex: null,
            isOpenCollapse: true,
            companyName: '',
            name: '',
            companyId: '',
            orgId: '',
            zipCode: '',
            telephone: '',
            address: '',
            typesense: false,
            typesensePage: null,
            showCreateModal: false,
            orgType: 'all',
        }
    }

    getPurchaseOrgs = (props) => {
        console.log("###### getPurchaseOrgs ########", props)

        if (this.state.loading) {
            return;
        }
        if (this.state.notMore) {
            return;
        }

        let first;
        this.setState({loading: true})
        if (this.state.last) {
            first = this.props.db.collection('organizations')
                .startAfter(this.state.last)
                .limit(this.state.buyerPerPage);
        } else {
            first = this.props.db.collection('organizations')
                .limit(this.state.buyerPerPage);
        }

        let paginate = first.get()
            .then((snapshot) => {
                this.setState({loading: false})
                if (snapshot.docs.length > 0) {
                    let last = snapshot.docs[snapshot.docs.length - 1];

                    this.setState({last: last})


                    let buyerData = this.state.dbBuyerOrgs;
                    snapshot.forEach((doc) => {
                        let data = doc.data();
                        data.id = doc.id;
                        buyerData.push(data)
                    })
                    this.setState({dbBuyerOrgs: buyerData}, () => {
                        let wrapper1 = document.getElementById('wrapper1');
                        let div1 = document.getElementById('div1');
                        let wrapper2 = document.getElementsByClassName('table-responsive')[0];
                        let div2 = document.getElementById('div2');

                        if (wrapper1 && div1 && wrapper2 && div2) {
                            div1.style.width = div2.offsetWidth+'px';

                            wrapper1.onscroll = function() {
                                wrapper2.scrollLeft = wrapper1.scrollLeft;
                            };
                            wrapper2.onscroll = function() {
                                wrapper1.scrollLeft = wrapper2.scrollLeft;
                            };
                        }
                    })
                } else {

                    this.setState({notMore: true, loading: false});
                }

            });

    }

    componentDidMount() {
        //this.getManuals();
        this.getPurchaseOrgs(this.props);
        window.addEventListener('scroll', event => this.watchCurrentPosition(), true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPurchaseOrgs(nextProps);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', event => this.watchCurrentPosition(), true);
    }

    watchCurrentPosition() {
        if (window.innerHeight + this.scrollTop() + 20 >= document.body.clientHeight) {
            console.log('reach end');
            this.onReachEnd();
        }
    }

    scrollTop() {
        return Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
        );
    }

    onReachEnd = () => {
        console.log("LAST:", this.state.last);
        if (this.state.typesense) {
            this.getTypesenseBuyerList()
        }
        this.getPurchaseOrgs(this.props);
    }
    showMenu = (itemId, index) => {
        let obj;
        obj = {
            showMenu: itemId,
            showMenuIndex: index
        }

        this.setState({showMenu: obj.showMenu, showMenuIndex: obj.showMenuIndex})
    }
    handleClickOutside = event => {
        this.setState({showMenu: null, showMenuIndex: null});
    };
    companyNameInputChange = (e) => {
        this.setState({
            companyName: e.currentTarget.value,
        });
    }
    nameInputChange = (e) => {
        this.setState({
            name: e.currentTarget.value,
        });
    }
    companyIdInputChange = (e) => {
        this.setState({
            companyId: e.currentTarget.value,
        });
    }
    orgIdInputChange = (e) => {
        this.setState({
            orgId: e.currentTarget.value,
        });
    }
    zipCodeInputChange = (e) => {
        this.setState({
            zipCode: e.currentTarget.value,
        });
    }
    telephoneInputChange = (e) => {
        this.setState({
            telephone: e.currentTarget.value,
        });
    }
    addressInputChange = (e) => {
        this.setState({
            address: e.currentTarget.value,
        });
    }
    handleSearchTypeSense = (e) => {
        this.setState({
            dbBuyerOrgs: [],
            last: null,
            typesense: true,
            typesensePage: 1,
            notMore: false
        }, () => {
            this.getTypesenseBuyerList();
        });
    }
    handleClear = (e) => {
        this.setState({
            companyName: '',
            name: '',
            companyId: '',
            orgId: '',
            zipCode: '',
            telephone: '',
            address: '',
            dbBuyerOrgs: [],
            last: null,
            typesense: false,
            typesensePage: 1,
            notMore: false,

        }, () => {
            this.getPurchaseOrgs();
        });
    }

    getTypesenseBuyerList = async () => {
        if (this.state.loading) {
            return;
        }

        if (this.state.notMore) {
            return;
        }

        this.setState({
            loading: true,
            typesense: true,
        });
        let tempResults = [];
        let collection = 'organizations';
        let notMore = false;
        let filters = 'buyer: true || reseller: true || maker: true';

        if (this.state.companyName) {
            filters += ` && company_name: ${this.state.companyName}*`;
        }
        if (this.state.name) {
            filters += ` && name: ${this.state.name}*`;
        }
        if (this.state.companyId) {
            filters += ` && company: ${this.state.companyId}*`;
        }
        if (this.state.orgId) {
            filters += ` && objectID: ${this.state.orgId}*`;
        }
        if (this.state.zipCode) {
            filters += ` && zipcode: ${this.state.zipCode}*`;
        }
        if (this.state.telephone) {
            filters += ` && TEL: ${this.state.telephone}*`;
        }
        if (this.state.address) {
            filters += ` && address: ${this.state.address}*`;
        }
        if (this.state.orgType && this.state.orgType!=='all') {
            if(this.state.orgType ==='buyer') {
                filters += ` && buyer: true`;
            }
            else if(this.state.orgType ==='reseller') {
                filters += ` && reseller: true`;
            }
            else if(this.state.orgType ==='maker') {
                filters += ` && maker: true`;
            }
        }
        let searchParameters;

        searchParameters = {
            'q': "*",
            'filter_by': filters,
            //'locale'    : 'ja',
            'enable_lazy_filter': true,
            'sort_by': 'company_name:asc',
            'page': this.state.typesensePage,
            'per_page': this.state.buyerPerPage
        }
        try {
            await (await getTypesenseClient()).collections(collection).documents().search(searchParameters).then((docs) => {
                docs.hits.forEach((data) => {
                    tempResults.push(data.document);
                })
            });
        } catch (e) {
            console.error('[typesense] buyer org search failed', e);
            this.setState({ loading: false });
            return;
        }
        let nextPage = this.state.typesensePage + 1;
        let newResults = this.state.dbBuyerOrgs.concat(tempResults);

        if (tempResults.length === 0) {
            notMore = true;
        }

        //console.log('tempResults', tempResults);
        this.setState({
            typesensePage: nextPage,
            dbBuyerOrgs: newResults,
            loading: false,
            notMore
        });
    }
    navigateToNew = () => {
        this.props.cProps.history.push('/orgList/new');
    }
    navigateToPreview = (row) => {
        this.props.cProps.history.push('/orgList/preview/'+row.id);
        //window.open("/orgList/preview/" + row.id, "_blank");
    }
    navigateToEdit = (row) => {
        this.props.cProps.history.push('/orgList/edit/'+row.id);
        //window.open("/orgList/edit/" + row.id, "_blank");
    }
    navigateToPreviewCompany = (id) => {
        this.props.cProps.history.push('/company/preview/'+id);
        //window.open("/orgList/edit/" + row.id, "_blank");
    }
    render() {
        const buyers = [];
        this.state.dbBuyerOrgs.forEach((buyerData, index) => {
            // const date = manual['date'].toDate().getFullYear() + '/'
            //     + (manual['date'].toDate().getMonth()+1) + '/'
            //     + manual['date'].toDate().getDate() + '';


            let data = {
                // '発行日':<span className="text-nowrap">{date}</span>,
                '会社名': <div className="companyText" onClick={() => this.navigateToPreviewCompany(buyerData.company)}>{buyerData['company_name']}</div>,
                '事業所名': <div className="overflow-hidden">{buyerData['name']}</div>,
                'U種別': <div
                    className="overflow-hidden">{buyerData.buyer ? '購入U' : (buyerData.reseller ? '販社U' : buyerData.maker && 'メーカーU')}</div>,
                '支払締日': <div
                    className="overflow-hidden">{buyerData['closingDate'] ? '毎月' + buyerData['closingDate'] + '日' : ''}</div>,
                '〒': <div className="overflow-hidden">{buyerData['zipcode']}</div>,
                '住所': <div className="overflow-hidden">{buyerData['address']}</div>,
                '電話番号': <div className="overflow-hidden">{buyerData['TEL']}</div>,
                'FAX番号': <div className="overflow-hidden">{buyerData['FAX']}</div>,
                'more': <div
                    style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', position: 'relative'}}>
                    <div className={'menuButton'} onClick={(e) => {
                        e.stopPropagation();
                        this.showMenu(buyerData.id, index);
                    }}>
                        <MDBIcon icon={'ellipsis-v'}/>
                        {this.state.showMenu === buyerData.id && this.state.showMenuIndex === index &&
                            <div className={'menuArea'} style={{width: '60px',position:'absolute !important'}}>
                                <div onClick={() => this.navigateToPreview(buyerData)}>
                                    詳細
                                </div>
                                <div onClick={() => this.navigateToEdit(buyerData)}>
                                    編集
                                </div>
                                <div>
                                    履歴
                                </div>
                                <div>
                                    削除
                                </div>
                            </div>
                        }
                    </div>
                </div>
                // 'ｼｽﾃﾑ登録日': <div className="overflow-hidden"></div>,
                //'action':
            };

            buyers.push(data);

        });

        const data = {
            columns: [
                {
                    label: '会社名',
                    field: '会社名',
                    sort: 'asc',
                    width: 100,
                    minimal: 'sm'
                },
                {
                    label: '事業所名',
                    field: '事業所名',
                    sort: 'disabled',
                    width: 80,
                    minimal: 'sm'
                },
                {
                    label: 'U種別',
                    field: 'U種別',
                    sort: 'disabled',
                    width: 50,
                    minimal: 'sm'
                },
                {
                    label: '支払締日',
                    field: '支払締日',
                    sort: 'disabled',
                    width: 80,
                    minimal: 'sm'
                },
                {
                    label: '〒',
                    field: '〒',
                    sort: 'disabled',
                    width: 80,
                    minimal: 'sm'
                },
                {
                    label: '住所',
                    field: '住所',
                    sort: 'disabled',
                    width: 80,
                    minimal: 'sm'
                },
                {
                    label: '電話番号',
                    field: '電話番号',
                    sort: 'disabled',
                    width: 80,
                    minimal: 'sm'
                },
                {
                    label: 'FAX番号',
                    field: 'FAX番号',
                    sort: 'disabled',
                    width: 80,
                    minimal: 'sm'
                },
                {
                    label: '',
                    field: 'more',
                    sort: 'disabled',
                    //width: 20,
                    minimal: 'sm'
                },
                // {
                //     label: 'ｼｽﾃﾑ登録日',
                //     field: 'ｼｽﾃﾑ登録日',
                //     sort: 'disabled',
                //     width: 80,
                //     minimal: 'sm'
                // },
                // {
                //     label: '',
                //     field: 'action',
                //     sort: 'disabled',
                //     width: 10,
                //     minimal: 'sm'
                // },
            ],
            rows: buyers
        }


        return (
            <>
                {
                    this.props.user && this.props.user.admin &&
                    <div>
                        {this.state.showMenu !== null && this.state.showMenuIndex !== null &&
                            <div style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                zIndex: 1041
                            }}
                                 onClick={() => this.handleClickOutside()}/>}
                        <h2>事業所一覧</h2>
                        <div style={{cursor: 'pointer', marginBottom: !this.state.isOpenCollapse && 20}}
                             onClick={() => this.setState({isOpenCollapse: !this.state.isOpenCollapse})}>
                            検索&nbsp; {this.state.isOpenCollapse ? <MDBIcon size={'lg'} fas icon="angle-up"/> :
                            <MDBIcon size={'lg'} fas icon="angle-down"/>}
                        </div>
                        <MDBCollapse isOpen={this.state.isOpenCollapse}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                border: '1px solid #B9B9B9',
                                padding: 10,
                                marginBottom: 20,
                                marginTop: 10
                            }}>
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 20}}>
                                    <div style={{
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        display: 'flex'
                                    }}>
                                        <span>会社名</span>
                                        <input
                                            type="text"
                                            id="companyName"
                                            className="form-control"
                                            name="companyName" width={'100px'}
                                            onChange={this.companyNameInputChange}
                                            value={this.state.companyName}
                                        />
                                    </div>
                                    <div style={{
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        display: 'flex'
                                    }}>
                                        <span>事業所名</span>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            name="name" width={'100px'}
                                            onChange={this.nameInputChange}
                                            value={this.state.name}
                                        />
                                    </div>
                                    <div style={{
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        display: 'flex'
                                    }}>
                                        <span>企業ID</span>
                                        <input
                                            type="text"
                                            id="companyId"
                                            className="form-control"
                                            name="companyId" width={'100px'}
                                            onChange={this.companyIdInputChange}
                                            value={this.state.companyId}
                                        />
                                    </div>
                                    <div style={{
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        display: 'flex'
                                    }}>
                                        <span>事業所ID</span>
                                        <input
                                            type="text"
                                            id="orgId"
                                            className="form-control"
                                            name="orgId" width={'100px'}
                                            onChange={this.orgIdInputChange}
                                            value={this.state.orgId}
                                        />
                                    </div>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 20,
                                    marginTop: 10
                                }}>
                                    <div style={{
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        display: 'flex'
                                    }}>
                                        {/*<span>法人番号</span>*/}
                                        {/*<input*/}
                                        {/*    type="text"*/}
                                        {/*    id="estNum"*/}
                                        {/*    className="form-control"*/}
                                        {/*    name="estNum" width={'100px'}*/}
                                        {/*    //onChange={this.handleNumChange}*/}
                                        {/*    //value={this.state.estNum}*/}
                                        {/*/>*/}
                                        <span>U種別</span>
                                        <div style={{margin: 0}}>
                                            <select
                                                className="browser-default custom-select"
                                                style={{width: 200}}
                                                onChange={(e) => this.setState({orgType: e.currentTarget.value})}
                                                value={this.state.orgType}
                                            >
                                                {/*<option>選択してください</option>*/}
                                                <option key={'all'} value={'all'}>{'全て'}</option>
                                                <option key={'buyer'} value={'buyer'}>{'購入U'}</option>
                                                <option key={'reseller'} value={'reseller'}>{'販社U'}</option>
                                                <option key={'maker'} value={'maker'}>{'メーカーU'}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div style={{
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        display: 'flex',
                                    }}>
                                        <span>TEL</span>
                                        <input
                                            type="text"
                                            id="zipCode"
                                            className="form-control"
                                            name="zipCode" width={'100px'}
                                            onChange={this.telephoneInputChange}
                                            value={this.state.telephone}

                                        />
                                    </div>
                                    <div style={{
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        display: 'flex'
                                    }}>
                                        <span>〒</span>
                                        <input
                                            type="text"
                                            id="telephone"
                                            className="form-control"
                                            name="telephone" width={'100px'}
                                            onChange={this.zipCodeInputChange}
                                            value={this.state.zipCode}
                                        />
                                    </div>
                                    <div style={{
                                        justifyContent: 'flex-start',
                                        flexDirection: 'column',
                                        display: 'flex'
                                    }}>
                                        <span>住所</span>
                                        <input
                                            type="text"
                                            id="address"
                                            className="form-control"
                                            name="address" width={'100px'}
                                            onChange={this.addressInputChange}
                                            value={this.state.address}
                                        />
                                    </div>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 20,
                                    marginTop: 10
                                }}>
                                    <MDBBtn size="sm4" color={'white'}
                                            onClick={this.handleClear}
                                            style={{width: 200}}>クリア</MDBBtn>
                                    <MDBBtn style={{width: 200}}
                                            disabled={(this.state.orgType || this.state.companyName || this.state.name || this.state.companyId || this.state.orgId || this.state.zipCode || this.state.telephone || this.state.address) ? false : true}
                                            onClick={this.handleSearchTypeSense}>検索</MDBBtn>
                                </div>
                            </div>

                        </MDBCollapse>
                        <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                            <MDBBtn size={'sm'} color="primary-color" style={{
                                backgroundColor: '#4285F4',
                                borderRadius: '2px',
                                fontSize: '14.4px',
                                color: "white"
                            }} onClick={this.navigateToNew}>新規組織登録</MDBBtn>
                        </div>
                        <div id="wrapper1" style={{height: 20, overflow: 'auto'}}>
                            <div id="div1" style={{height: 20}}>
                            </div>
                        </div>
                        <MDBTable btn small striped={false} id={"div2"}>
                            <MDBTableHead color="primary-color" textWhite columns={data.columns}/>
                            <MDBTableBody rows={data.rows}/>
                        </MDBTable>
                        {this.state.loading && <div className="d-flex justify-content-center mt-5"><MDBSpinner/></div>}
                    </div>
                }
            </>
        )

    }
}

export default BuyerOrgList;